import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, IKeyValueInterface, Entity, PermissionType, Permission, WeGoAuthorizedLink } from '../../shared/config';
import { AdminOfOrganizationService } from '../models/admin-of-organization.service';
import { AdminOfOrganizationModel } from '../models/admin-of-organization.model';
import { RoleAvailabilityModel } from '../../roleavailability/models/roleavailability.model';
import { retry } from 'rxjs/operator/retry';
import { PersonService } from '../../person/models/person.service';
import { OrganizationAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';
import { OrganizationService } from '../../organization/models/organization.service';

@Component({
  selector: 'wego-admin-of-organization',
  template: require('../views/admin-of-organization-list.component.html'),
  providers: [AdminOfOrganizationService, PersonService, OrganizationService],

})
export class AdminOfOrganizationListComponent implements OnInit {
  addOrganizationAdminLink: WeGoAuthorizedLink;
  inviteTitle: any;
  roleAvailabilityList: RoleAvailabilityModel[];
  DataListModel: DataListModel;
  sub: any;
  organizationHashId: string;
  organizationAdminList: AdminOfOrganizationModel[];
  errorModel: IKeyValueInterface[];
  roleColumns: number = 0;
  ToggleRoleName: string;
  ToggleUserName: string;
  ToggleAddRole: boolean;
  ToggleRoleHashId: string;
  ToggleRolePersonHashID: string;
  toggleRoleMsg: string;
  toggleRoleTitle: string;
  apiErrorMsg: string;
  isLoading: boolean;
  deletePersonMasterHashId: string;
  resetPasswordPersonHashId: string;
  message: string;
  errorMessage: string;
  organizationName: string;
  urlDefaultPage: string;
  urlOrganizationList: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  validateMessage: string;
  blockUnblockMsg: string;
  blockUnblockCompanyAdminHashId: string;
  blockMsg: string;
  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  private organizationList: string;

  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('toggleRolePopup') public toggleRolePopup: any;
  @ViewChild('inviteAdminModal') public inviteAdminModal: any;

  constructor(private adminOfOrganizationService: AdminOfOrganizationService,
    private personService: PersonService,
    private organizationService: OrganizationService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService) {
  }

  get isAnyChecked(): boolean {
    if (this.organizationAdminList) {
      let isCheck = this.organizationAdminList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.organizationAdminList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.organizationAdminList) {
      return this.organizationAdminList.some(x => x.isDeletable);
    }
    else { return false; }

  }

  ngOnInit() {
    this.module = this.translate.instant('LblOrganizationAdmin');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.organizationList = this.translate.instant('LblListPage', [this.translate.instant('LblOrganization')]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlOrganizationList = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_LIST);
    this.inviteTitle = this.translate.instant('LblInvite') + " " + this.translate.instant('LblOrganizationAdmin');
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.organizationHashId = params['id'] || '';
        if (this.organizationHashId != '') {
          this.addOrganizationAdminLink = new WeGoAuthorizedLink("",
            Permission.PR_ORGANIZATION_ADMIN_OVERVIEW, PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblInvite', Entity.ORGANIZATION, this.organizationHashId);

          this.GetOrganizationDetails();
        }
      });
  }

  public RoleAvailabilityList() {
    this.isLoading = true;
    if (this.organizationHashId) {
      this.adminOfOrganizationService.GetAllRoleAvailability(new DataListModel(), this.organizationHashId)
        .subscribe(
          res => {
            this.roleAvailabilityList = res.data;
            this.roleColumns = this.roleAvailabilityList.length;
            this.GetAdminOfOrganizationList();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          });
    }
  }

  public GetOrganizationDetails() {
    if (this.organizationHashId) {
      this.isLoading = true;
      this.organizationService.GetOrganizationBasicDetail(this.organizationHashId)
        .subscribe(
          res => {
            if (res.data) {
              this.organizationName = res.data.entityName;
              this.RoleAvailabilityList();
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          });
    }
  }

  public GetAdminOfOrganizationList() {
    this.isLoading = true;
    this.adminOfOrganizationService.GetAdminOfOrganizationList(this.organizationHashId, this.DataListModel)
      .subscribe(
        res => {
          this.organizationAdminList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.organizationAdminList = [];
          this.DataListModel.infoMessage = error;
          this.isLoading = false;
        });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetAdminOfOrganizationList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetAdminOfOrganizationList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetAdminOfOrganizationList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetAdminOfOrganizationList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.adminOfOrganizationService.ExportAdminOfOrganizationList(this.organizationHashId, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "OrganizationAdmin" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });;
  }

  public DeleteAdminOfOrganization(deleteOrganizationAdminList: string[]) {
    this.isLoading = true;
    this.adminOfOrganizationService.DeleteAdminOfOrganization(this.organizationHashId, deleteOrganizationAdminList)
      .subscribe(
        res => {
          this.DataListModel.currentPage = 1;
          this.GetAdminOfOrganizationList();
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
          this.ShowSuccessPopup();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public OnParentCheck(isChecked: boolean) {
    this.organizationAdminList.filter(x => x.isDeletable).forEach(x => x.isChecked = isChecked);
  }

  public ShowAlertModal(deletePersonMasterHashId?: string): void {
    if (deletePersonMasterHashId) {
      this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deletePersonMasterHashId = deletePersonMasterHashId;
    }
    else {
      this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.deletePersonMasterHashId = "";
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteAdminOfOrganizationList: any[];
    if (this.isMultipleDelete)
      deleteAdminOfOrganizationList = this.organizationAdminList.filter(x => x.isChecked).map(x => x.personMasterHashId);
    else
      deleteAdminOfOrganizationList.push(this.deletePersonMasterHashId);

    this.DeleteAdminOfOrganization(deleteAdminOfOrganizationList);
    this.alertModal.hide();
  }

  // Add Organization admin popup
  public ShowAddOrganizationAdminModal() {
    this.ShowInviteAdminModal();
  }

  public ToggleRoleAvailibility(personHashID: string, roleHashId: string, personRolesHashIds: string[], roleName: string, userName: string) {
    this.ToggleRolePersonHashID = personHashID;
    this.ToggleRoleHashId = roleHashId;
    this.ToggleUserName = userName;
    this.ToggleRoleName = roleName;

    if (this.CheckRole(personRolesHashIds, roleHashId)) {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [userName, roleName]);
      this.ToggleAddRole = false;
      this.ShowToggleRolePopup();
    } else {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [userName, roleName]);
      this.ToggleAddRole = true;
      this.ShowToggleRolePopup();
    }
  }

  public ShowToggleRolePopup(): void {
    this.toggleRolePopup.show();
  }

  public HideToggleRolePopup(): void {
    this.ToggleRolePersonHashID = '';
    this.ToggleRoleHashId = '';
    this.ToggleUserName = '';
    this.ToggleRoleName = '';

    this.toggleRolePopup.hide();
  }

  public ConfirmToggleRolePopup(): void {
    if (this.ToggleAddRole) {
      this.adminOfOrganizationService.AddAdminOfOrganizationRole(this.organizationHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
        .subscribe(
          res => {
            this.GetAdminOfOrganizationList();
            this.popupMsg = this.translate.instant('LblRoleAddedSuccess', [this.ToggleUserName, this.ToggleRoleName]);
            this.HideToggleRolePopup();
            this.ShowSuccessPopup();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
            this.HideToggleRolePopup();
          });
    } else {

      this.adminOfOrganizationService.DeleteAdminOfOrganizationRole(this.organizationHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
        .subscribe(
          res => {
            this.GetAdminOfOrganizationList();
            this.popupMsg = this.translate.instant('LblRoleDeletedSuccess', [this.ToggleUserName, this.ToggleRoleName]);
            this.HideToggleRolePopup();
            this.ShowSuccessPopup();
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
            this.HideToggleRolePopup();
          });

    }
  }

  //Reset company admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
            this.ShowSuccessPopup();
          }
          else {
            this.popupMsg = this.translate.instant('LblResetPasswordFailure');
            this.popupTitle = this.translate.instant('LblWarning');
            this.ShowSuccessPopup();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }


  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = "";
    this.resetPasswordModal.hide();
  }
  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    console.log(this.resetPasswordPersonHashId);
    this.ResetPersonPassword(this.resetPasswordPersonHashId);
  }

  public ResendActivationMail(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.personService.ReSendActivationMail(personHashID, this.organizationHashId)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.translate.instant('LblResendActivationMailSuccess');
            this.ShowSuccessPopup();
          }
          else {
            this.popupMsg = this.translate.instant('LblResendActivationMailFailure');
            this.popupTitle = this.translate.instant('LblWarning');
            this.ShowSuccessPopup();
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();

  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ShowInviteAdminModal(): void {
    this.inviteAdminModal.availableRoles = JSON.parse(JSON.stringify(this.roleAvailabilityList));
    this.inviteAdminModal.availablePersons = '';
    this.inviteAdminModal.show();
  }

  public HideInviteAdminModal(): void {
    this.inviteAdminModal.hide();
  }

  public SuccessInviteAdminModalClick($event: any): void {
    let adminInvitation = new OrganizationAdminInvitationModel();
    adminInvitation.emailAddress = $event.emailAddress;
    adminInvitation.personHashId = $event.personHashId;
    adminInvitation.roleHashIdList = $event.roleHashIdList;
    adminInvitation.organizationHashId = this.organizationHashId;

    this.adminOfOrganizationService.InviteAdminOfOrganization(adminInvitation)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.translate.instant('LblInvitationMailSuccess');
            this.HideInviteAdminModal();
            this.ShowSuccessPopup();
          }
          else {
            this.inviteAdminModal.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
          this.HideInviteAdminModal();
        });
  }

  public SearchEmailAddress($event: any): void {
    let emailAddress = $event.emailAddress;
    this.isLoading = true;
    this.adminOfOrganizationService.GetPersonListToInvite(this.organizationHashId, emailAddress)
      .subscribe(
        res => {
          if (res.data) {
            this.inviteAdminModal.availablePersons = res.data;
            this.inviteAdminModal.errorModel = [];
          } else {
            this.inviteAdminModal.errorModel = res.error;
          }
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public CheckRole(existingArray: string[], currentRole: string) {
    return existingArray.some(x => x == currentRole);
  }

  get isResetCookieAccess(): boolean {
    if (this.organizationAdminList) {
      return this.organizationAdminList.some(x => !x.twoFaDisabled);
    } else {
      return false;
    }
  }

  get isTwoFaResetKeyAccess(): boolean {
    if (this.organizationAdminList) {
      return this.organizationAdminList.some(x => x.resetKeyEnabled);
    } else {
      return false;
    }
  }

  public ResetPersonCookies(personHashID: string) {
    ;
    this.personService.ResetTwoFaCookie(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblCookieResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblCookieResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ResetPersonTwoFA(personHashID: string) {

    this.personService.ResetTwoFaKey(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblKeyResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblKeyResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-organization/components/admin-of-organization-list.component.ts